import {AuthGuard} from '../../shared/guards/AuthGuard';
import {DetalheClientesPresentation} from './components';
import {Sidebar} from '../../shared/components';


export const DetalheClientesPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <DetalheClientesPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};